<template>
  <div class="text-row">
    <div class="left">
      <div v-if="leftLabel">{{leftLabel}}</div>
      {{left}}
    </div>
    <div class="right">
      <div v-if="rightLabel">{{rightLabel}}</div>
      {{right}}
    </div>
  </div>
</template>
<script lang="ts" setup>

defineProps<{
  left:string,
  right:string,
  leftLabel?:string,
  rightLabel?:string,
}>();

</script>
<style lang="scss">

.text-row{
  display: grid;
  grid-template-columns: 1fr 1fr;
  .left, .right {
    div {
      font-weight: bold;
    }
  }
  .right {
    text-align: right;
  }
  background: var(--pidz-white);
  color: var(--pidz-body-text);
  padding: 12px;
}

</style>
